<template>
    <div class="new-input-box activityPageSettingsBox">
        <jd-title label="活动页设置" type="bold"></jd-title>
        <slot name="otherSetHead"></slot>
        <el-form-item v-if="isNeedCustomerPaperworkData" label="活动主题:">
            <el-input placeholder="请输入活动标题" style="width: 425px;" show-word-limit
                v-model="customerPaperworkData[defaultTitleKey]" :maxlength="10"></el-input>
            <el-tooltip class="item" effect="light" content="不填c端则不显示" placement="bottom">
                <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                </el-button>
            </el-tooltip>
        </el-form-item>
        <el-form-item v-if="isNeedCustomerPaperworkData&&isShowDesc" label="活动说明:">
            <el-input placeholder="请输入活动说明" style="width: 425px;" show-word-limit
                v-model="customerPaperworkData[defaultDescKey]" :maxlength="descLimit"></el-input>
            <el-tooltip class="item" effect="light" content="不填c端则不显示" placement="bottom">
                <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                </el-button>
            </el-tooltip>
        </el-form-item>
        <el-form-item v-if="isNeedCustomerPaperworkData" :label="`${themeTitle}文字颜色:`">
            <div style="display: flex;align-items: center;">
                <el-color-picker v-model="customerPaperworkData[defaultTitleColorKey]" class="colorPicker">
                </el-color-picker>
                <jd-button type="blueText" style="margin-left: 20px"
                    @click="customerPaperworkData[defaultTitleColorKey] = defaultRgb">重置</jd-button>
            </div>
        </el-form-item>
        <el-form-item v-if="isNeedCustomerPaperworkData&&isShowExtra" :label="`${firstLabel}:`">
            <el-input :placeholder="`请输入${firstLabel}`" style="width: 425px;" show-word-limit
                v-model="customerPaperworkData[defaultFirstKey]" :maxlength="12"></el-input>
            <el-tooltip class="item" effect="light" content="不填c端则不显示" placement="bottom">
                <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                </el-button>
            </el-tooltip>
        </el-form-item>
        <el-form-item v-if="isNeedCustomerPaperworkData&&isShowExtra" :label="`${secondLabel}:`">
            <el-input :placeholder="`请输入${secondLabel}`" style="width: 425px;" show-word-limit
                v-model="customerPaperworkData[defaultSecondKey]" :maxlength="12"></el-input>
            <el-tooltip class="item" effect="light" content="不填c端则不显示" placement="bottom">
                <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                </el-button>
            </el-tooltip>
        </el-form-item>
        <!-- 中间配置 -->
        <slot name="otherSetMiddle"></slot>
        <el-form-item v-if="isNeedShowTemplate" label="系统模板:">
            <div style="display: flex;flex-wrap: wrap;max-width: 650px;">
                <!-- {{ item }} -->
                <div style="width: 80px;height: 150px;overflow: hidden;margin-right: 15px;margin-bottom: 10px;position: relative;cursor: pointer;border-radius: 2px;" v-for="(item, index) in giftList" :key="item.id" @click="selectTemplate(index,item.id,item)">
                    <img :src="item[templatekey]" style="width: 100%;height: auto;">
                    <div style="width: 80px;overflow: hidden;position: absolute;background: rgba(0, 0, 0, .5);width: 100%;color: #ffffff;padding: 2px;bottom: 0px;font-size: 12px;line-height: 16px;white-space: nowrap;text-overflow: ellipsis;text-align: center;">
                        {{ item.imageName }}
                    </div>
                    <img v-if="templateId == item.id" style="position: absolute;top: 0px;right: 0px;width: 15px;height: 15px;" src="https://yunqi-hd-public.tos-cn-beijing.volces.com/image/activityBtn/temp_selected.png"></img>
                </div>
            </div>
        </el-form-item>
        <el-form-item v-if="isNeedSetBG" label="更换背景图:">
            <div class="miniAppPic">
                <div class="top" style="display: flex;align-items: center;">
                    <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                        :before-upload="beforeUpload" :on-success="handleUpload">
                        <div style="width: 80px;height: 150px;overflow: hidden;" v-if="uploadImg">
                            <img :src="uploadImg" style="width: 100%;height: auto;"></img>
                        </div>
                        <jd-button v-else type="blueLine">自定义上传</jd-button>
                    </el-upload>
                    <jd-button style="margin: 0 10px;" type="blueText" @click="uploadImg = '';updateImg()">重置</jd-button>
                    <span style="color: #AAAAAA;" v-if="otherSize">尺寸建议：{{ otherSize }}</span>
                    <span style="color: #AAAAAA;" v-else-if="isShowDesignNumber">尺寸建议：{{ widthNumber }}*{{ heightNumber }}px</span>
                    <jd-button v-if="downloadTemplateUrl" @click="downloadTemplate(downloadTemplateUrl)" style="margin-left: 10px;" type="blueText">下载模板</jd-button>
                    <jd-button v-if="designSpecificationsUrl" style="margin-left: 10px !important;" type="blueText" @click="isShowDesignSpecifications = true">查看设计规范</jd-button>
                </div>
            </div>
        </el-form-item>
        <div v-if="!isCustomPreview" class="Preview">
            <div style="width: 100%;height: 100%;overflow: hidden;border-radius: 8px;position: relative;">
                <img :src="findSrc()" style="width: 100%;height: auto;"></img>
            </div>
            <div style="position: absolute;width: calc(100% - 16px);display: flex;justify-content: center;color: #999999;bottom: -25px;box-sizing: border-box;font-size: 16px;">预览图</div>
        </div>
        <div v-else class="customPreview">
            <slot name="customPreview"></slot>
        </div>
        <!-- 其他配置 -->
        <slot name="otherSet"></slot>
        <template v-if="isShowShopName">
            <jd-title label="展示店铺"></jd-title>
            <el-form-item label="小程序店铺信息：">
                <el-radio-group v-model="customerPaperworkData.shopNameType">
                    <el-radio :label="0">统一显示配置店铺</el-radio>
                    <el-radio :label="1" v-if="isShowShopNameByChannel">
                        <span>根据店铺渠道链接显示店铺名称</span>
                        <el-popover
                            placement="top"
                            title=""
                            width="600"
                            trigger="hover"
                        >   
                            <template #reference>
                                <i class="new-icon-box ml8" slot="reference"></i>
                            </template>
                            <template #default>
                                <img style="width: 600px;height: auto;" src="https://cdn-image.yucrm.cn//hd/images/13315956_2f887eef5db64f249a93d47cc4a61bbc.png" />
                            </template>
                        </el-popover>
                    </el-radio>
                    <el-radio :label="2">不显示店铺信息</el-radio>
                </el-radio-group>
            </el-form-item>
        </template>
        <!-- 更多活动配置 -->
        <template v-if="isShowMoreSet">
            <jd-title label="更多活动配置"></jd-title>
            <el-form-item label="活动浮窗：">
                <el-radio-group v-model="customerPaperworkData.moreActSet.isShowFloatWindow" @change="changeShowFloatWindow">
                    <el-radio :label="0">不显示</el-radio>
                    <el-radio :label="1">显示</el-radio>
                </el-radio-group>
                <div class="set-box" v-if="customerPaperworkData.moreActSet.isShowFloatWindow">
                    <el-form-item label="浮窗图：" label-width="auto">
                        <div class="floatImg">
                            <uploadCom :imgUrl.sync="customerPaperworkData.moreActSet.floatWindowImg"
                            />
                            <jd-button type="blueText" class="ml8" @click="customerPaperworkData.moreActSet.floatWindowImg = 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/float-icon.png'">重置</jd-button>
                            <span class="upload-tip ml8">尺寸建议：100px*100px</span>
                        </div>
                    </el-form-item>
                    <jumpLinkCom v-model="customerPaperworkData.moreActSet" jumpLabel="跳转链接:" :isRequired="false"/>
                </div>
            </el-form-item>
            <el-form-item label="活动banner：">
                <el-radio-group v-model="customerPaperworkData.moreActSet.isShowBanner" @change="changeShowBanner">
                    <el-radio :label="0">不显示</el-radio>
                    <el-radio :label="1">显示</el-radio>
                </el-radio-group>
                <actBannerCom class="mt12" v-if="customerPaperworkData.moreActSet.isShowBanner":list.sync="customerPaperworkData.moreActSet.bannerList" :tableInfo="tableInfo"/>
            </el-form-item>
        </template>
        <el-dialog
            title="设计规范"
            :visible.sync="isShowDesignSpecifications"
            width="800px"
        >
            <img style="width: 760px;object-fit: cover;" :src="designSpecificationsUrl"/>
        </el-dialog>
    </div>
</template>

<script>
import uploadCom from "./commCustomizationSet/uploadCom.vue"
import jumpLinkCom from "./jumpLinkCom.vue"
import actBannerCom from "./actBannerCom.vue"
export default {
    components: {
        uploadCom,
        jumpLinkCom,
        actBannerCom
    },
    model: {
        prop: "customerPaperwork",
        event: "customerPaperworkUpdate",
    },
    props: {
        customerPaperwork: {
            type: Object,
            default: {},
        },
        giftList:{
            type: Array,
            default:[]
        },
        templateId:{
            type: String,
            default:""
        },
        widthNumber:{
            type: Number,
            default:0
        },
        heightNumber:{
            type: Number,
            default:0
        },
        isNeedCustomerPaperworkData:{
            type: Boolean,
            default:true
        },
        templatekey:{
            type: String,
            default:"imageUrl"
        },
        isNeedShowTemplate:{
            type: Boolean,
            default:true
        },
        isNeedSetBG:{
            type: Boolean,
            default:true
        },
        // 自定义背景图JSON
        cusTemplateJSON: {
            type: String,
            default: ""
        },
        defaultRgb:{
            type: String,
            default: "#1a1a1a"
        },
        isCustomPreview:{ //自定义预览
            type: Boolean,
            default: false
        },
        // 活动标题字段
        defaultTitleKey: {
            type: String,
            default: "title"
        },
        // 活动说明字段
        defaultDescKey: {
            type: String,
            default: "desc"
        },
        // 活动标题文字字段
        defaultTitleColorKey: {
            type: String,
            default: "titleColor"
        },
        // 预览图key
        previewKey: {
            type: String,
            default: "secondImageUrl"
        },
        // 下载模板url
        downloadTemplateUrl:{
            type: String,
            default: ""
        },
        // 设计图下载URL
        designSpecificationsUrl: {
            type: String,
            default: ""
        },
        defaultFirstKey: {
            type: String,
            default: "firstTitle"
        },
        defaultSecondKey: {
            type: String,
            default: "secondTitle"
        },
        // 额外字段配置
        isShowExtra: {
            type: Boolean,
            default: false
        },
        firstLabel: {
            type: String,
            default: "试用礼主题"
        },
        secondLabel: {
            type: String,
            default: "正装礼主题"
        },
        themeTitle: {
            type: String,
            default: "标题"
        },
        // 是否显示尺寸
        isShowDesignNumber:{
            type: Boolean,
            default: true
        },
        // 活动说明字数限制
        descLimit: {
            type: Number,
            default: 25
        },
        // 是否显示活动说明
        isShowDesc:{
            type: Boolean,
            default: true
        },
        otherSize: {
            type: String,
            default: ""
        },
        // 是否显示店铺名称配置
        isShowShopName:{
            type: Boolean,
            default: false
        },
        // 是否根据渠道显示店铺名称
        isShowShopNameByChannel:{
            type: Boolean,
            default: false
        },
        // 是否显示更多活动配置
        isShowMoreSet:{
            type: Boolean,
            default: false
        },
    },
    computed: {
        customerPaperworkData:{
            get: function () {
                return this.customerPaperwork;
            },
            set: function (val) {
                this.$emit("customerPaperworkUpdate", val);
            },
        },
    },
    watch: {
        cusTemplateJSON: {
            handler: function(v) {
                if(v) {
                    try {
                        const obj = JSON.parse(v);
                        this.uploadImg = obj.activityBgImg;
                    } catch (error) {
                        console.log(error);
                        this.uploadImg = "";
                    }
                } else {
                    this.uploadImg = "";
                }
            },
            immediate: true
        },
        customerPaperwork: {
            handler: function(v) {
                if(this.isShowShopName) {
                    if(v.shopNameType){
                        this.$set(this.customerPaperwork, "shopNameType", v.shopNameType);
                    } else {
                        this.$set(this.customerPaperwork, "shopNameType", 0);
                    }
                }
                // 新增活动浮窗配置
                if(this.isShowMoreSet) {
                    if(v.moreActSet){
                        this.$set(this.customerPaperwork, "moreActSet", v.moreActSet);
                    } else {
                        this.$set(this.customerPaperwork, "moreActSet", {
                            isShowFloatWindow: 0,
                            floatWindowImg: "",
                            goShopSetting: 0,
                            goShopAppId: "",
                            goShopUrl: "",
                            isShowBanner: 0,
                            bannerList: []
                        });
                    }
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            uploadSize:'',
            uploadImg:"",
            isShowDesignSpecifications: false,
            tableInfo: [
                {
                    label: "banner图",
                    prop: "bannerUrl",
                    slot: "bannerUrlSlot",
                },
                {
                    label: "跳转链接",
                    prop: "goShopUrl",
                    slot: "goShopUrlSlot"
                },
                {
                    label: "操作",
                    prop: "operation",
                    slot: "operationSlot",
                },
            ]
        }
    },
    created() { },
    mounted() { },
    methods: {
        changeShowBanner() {
            this.customerPaperworkData.moreActSet.bannerList = [];
        },
        changeShowFloatWindow(val) {
            if(val==1) {
                this.customerPaperworkData.moreActSet.floatWindowImg = "https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/float-icon.png";
            } else {
                this.customerPaperworkData.moreActSet.floatWindowImg = "";
            }
            this.customerPaperworkData.moreActSet.goShopSetting = 0;
            this.customerPaperworkData.moreActSet.goShopAppId = "";
            this.customerPaperworkData.moreActSet.goShopUrl = "";
        },
        lookDesignSpecifications(){
            this.isShowDesignSpecifications = true
        },
        downloadTemplate(url) {
            let a = document.createElement("a");
            a.style.display = "none";
            a.href = url; 
            a.setAttribute("download", name); //
            // 将生成的URL设置为a.href属性
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        findSrc(){
            if (this.uploadImg) {
                return this.uploadImg
            }
            let resData = ""
            this.giftList.forEach(item => {
                if(item.id == this.templateId){
                    resData = item[this.previewKey]
                }
            });
            return resData
        },
        selectTemplate(index,id,items){
            this.$emit("selectTemplate",index,id,items)
        },
        beforeUpload(file){
            let _this = this
            let image = new Image()
            let _URL = window.URL || window.webkitURL
            image.onload = function () {
                console.log("this.widthNumber*this.heightNumber",_this.widthNumber,_this.heightNumber)
                if (_this.widthNumber === 0 && _this.heightNumber === 0) {
                    file.isFlag = true
                    _this.uploadSize = true
                    return
                }
                const valid = (image.width == _this.widthNumber && image.height == _this.heightNumber)
                file.isFlag = valid
                _this.uploadSize = valid
                console.log(valid);
                if (valid) {
                } else {
                    _this.$message.info('图片宽高不符合要求,请重新上传')
                    sizetype = false
                    return false
                }
            }
            image.src = _URL.createObjectURL(file)
            console.log(file);
            const isLt3M = file.size < 1024 * 1024;

            let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
            let sorts = [".png", ".jpg"]
            let sizetype = false
            if (!isLt3M) {
                this.$message.info("上传图片大小不能超过 1MB");
                return false
            }
            if (sorts.indexOf(type) < 0) {
                this.$message.info("所选文件格式不符，请重新选择");
                return false;
            }
        },
        handleUpload(res){
            if (res.code != 1) {
                this.$message.error(res.message);
            } else {
                console.log(this.uploadSize);
                if (this.uploadSize) {
                    this.uploadImg = res.data;
                    this.$forceUpdate()
                    this.updateImg()
                }
            }
        },
        updateImg() {
            let obj = {
                activityBgImg: this.uploadImg
            }
            if(this.uploadImg) {
                this.$emit("update:cusTemplateJSON",JSON.stringify(obj))
            } else {
                this.$emit("update:cusTemplateJSON","")
            }
            this.$emit("cusTemplateJSONChange",JSON.parse(JSON.stringify(obj)))
        }
    }
}
</script>

<style lang="scss" scoped>
.activityPageSettingsBox{
    position: relative;
    .customPreview{
        position: absolute;
        top: 0;
        left: 900px;
        z-index: 99;
    }
    .Preview{
        position: absolute;
        top: 0;
        left: 900px;
        width: 284px;
        height: 564px;
        box-shadow: 0 4px 20px 0 rgba(18, 10, 60, .1490);
        border-radius: 8px;
        box-sizing: border-box;
        overflow: visible;
        padding: 10px;
    }
}
.miniAppPic {
    position: relative;

    .image-slot {
        width: 100%;
        height: 100%;
        background: #f5f7fa;
        text-align: center;
        padding-top: 43px;

        i {
            font-size: 30px;
            color: #909399;
        }
    }

    .top {
        position: relative;
        left: 8px;
        display: flex;

        .returnBtn {
            border-radius: 4px;
            width: auto;
            height: 32px;
            line-height: 32px;
            text-align: center;
            color: #fe4d45;
            background: rgba(254, 77, 69, 0.1);
            border: 1px solid #fe4d45;

            &:hover {
                color: #fff;
                background: #fe4d45;
            }
        }

        .reset {
            color: #fe4d45;
            cursor: pointer;
            font-size: 14px;
            margin-left: 15px;
        }
    }

    .bottom {
        position: relative;
        top: 15px;
        // margin-left: 100px;

        .elImg {
            width: 120px;
            height: 120px;
            border: 1px dashed #dddddd;
            border-radius: 5px;
        }

        .tips1 {
            position: absolute;
            left: 135px;
            top: 22px;
            line-height: 2;
            color: #aaaaaa;
            font-size: 13px;
        }
    }
}
.set-box {
    width: 700px;
    padding: 20px;
    background: #f4f6fa;
    border-radius: 4px 4px 4px 4px;
    .floatImg {
        display: flex;
        align-items: flex-end;
        .upload-tip {
            font-size: 14px;
            color: #999999;
        }
    }
}
</style>